import { render, staticRenderFns } from "./alt-timeline-item.vue?vue&type=template&id=33a71f7f&scoped=true&"
import script from "./alt-timeline-item.vue?vue&type=script&lang=ts&"
export * from "./alt-timeline-item.vue?vue&type=script&lang=ts&"
import style0 from "./alt-timeline-item.vue?vue&type=style&index=0&id=33a71f7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a71f7f",
  null
  
)

export default component.exports